module.exports = __webpack_public_path__ + "static/media/izlozba (4).ef088275.jpg";